'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Fileinfofill;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Fileinfofill(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 14 16',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M12,1.5 L15.75,5.25 L15.75,15.756 C15.7495861,16.1670211 15.4162714,16.5 15.00525,16.5 L2.99475,16.5 C2.58491666,16.4971441 2.2532688,16.1658303 2.25,15.756 L2.25,2.244 C2.25,1.833 2.58375,1.5 2.99475,1.5 L12,1.5 Z M8.25,5.25 L8.25,6.75 L9.75,6.75 L9.75,5.25 L8.25,5.25 Z M8.25,8.25 L8.25,12.75 L9.75,12.75 L9.75,8.25 L8.25,8.25 Z'
  }));
}
Fileinfofill.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};